import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import NavHeader from '~/components/NavHeader';
import Scroller from '~/utils/components/ScrollingContainer';
import './index.scss';

const propTypes = {
  camouflageHeader: PropTypes.bool,
  children: PropTypes.any,
  className: PropTypes.string,
  confirm: PropTypes.bool,
  contentClassName: PropTypes.string,
  'data-testid': PropTypes.string,
  isNamesNumbersNav: PropTypes.bool,
  navBackText: PropTypes.string,
  scrollerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  scrolling: PropTypes.bool,
  showBackIconAndText: PropTypes.bool,
  style: PropTypes.object,
  title: PropTypes.string,
  onClick: PropTypes.func,
  onNavBack: PropTypes.func,
  onNavClose: PropTypes.func
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
export default class ContentCard extends Component {
  static displayName = 'ContentCard';
  static propTypes = propTypes;

  static defaultProps = {
    camouflageHeader: false,
    confirm: false,
    navBackText: undefined,
    scrolling: true,
    showBackIconAndText: false,
    style: {}
  };

  state = {
    headerHeight: 0
  };

  componentDidMount() {
    if (this._header) {
      this.setState({headerHeight: this._header.offsetHeight});
    }
  }

  render() {
    const contentClasses = classnames(
      this.props.contentClassName,
      'ndx-ContentCard-content'
    );

    const navHeaderClass = classnames({
      'camouflage-Header': this.props.camouflageHeader
    });

    return (
      <div
        data-testid={this.props['data-testid']}
        className={classnames(this.props.className, 'ndx-ContentCard')}
        style={this.props.style}
        onClick={this.props.onClick}>
        <NavHeader
          backText={this.props.navBackText}
          className={navHeaderClass}
          confirm={this.props.confirm}
          domRef={header => (this._header = header)}
          isNamesNumbersNav={this.props.isNamesNumbersNav}
          title={this.props.title}
          onBack={this.props.onNavBack}
          onClose={this.props.onNavClose}
          showBackIconAndText={this.props.showBackIconAndText}
        />
        {this.props.scrolling ? (
          <Scroller className={contentClasses} ref={this.props.scrollerRef}>
            {this.props.children}
          </Scroller>
        ) : (
          this.props.children
        )}
      </div>
    );
  }
}
